var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UiInput',{attrs:{"label":"Parolă nouă","type":"password","icon":"fa fa-lock","value":_vm.firstStep.password,"error":_vm.errors.password},on:{"input":_vm.updatePassword,"blur":_vm.validatePassword,"focus":function($event){_vm.errors.password = ''}}}),_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.apiError))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }